import { useLinkTo } from '@react-navigation/native';
import { Toast } from 'react-native-toast-message/lib/src/Toast';
import { useTranslation } from 'react-i18next';

import { showErrorToUser } from '@pletly/ui';

import {
	useYourCommunityGroupsQuery,
	YourCommunityGroupsDocument,
} from './__generated__/yourGroups.generated';
import { useRejectCommunityJoinInviteMutation } from './__generated__/rejectInvite.mutation.generated';
import { useAcceptCommunityJoinInviteMutation } from './__generated__/acceptInvite.mutation.generated';

export const useYourCommunities = () => {
	const navigate = useLinkTo();
	const { loading, data, refetch } = useYourCommunityGroupsQuery();
	const { t } = useTranslation();

	const [acceptJoinInvite] = useAcceptCommunityJoinInviteMutation({
		refetchQueries: [YourCommunityGroupsDocument],
	});
	const [rejectJoinInvite] = useRejectCommunityJoinInviteMutation({
		refetchQueries: [YourCommunityGroupsDocument],
	});

	const acceptJoinInvitePress = async (inviteId: string, groupUuid: string) => {
		try {
			await acceptJoinInvite({
				variables: {
					inviteId,
				},
			});
			navigate(`/communities/${groupUuid}`);
		} catch (error) {
			console.error(error);

			if (error instanceof Error) {
				showErrorToUser(error);
			}
		}
	};

	const rejectJoinInvitePress = async (inviteId: string) => {
		try {
			await rejectJoinInvite({
				variables: {
					inviteId,
				},
			});
			Toast.show({
				type: 'success',
				text1: t('community.invite-removed'),
			});
		} catch (error) {
			console.error(error);

			if (error instanceof Error) {
				showErrorToUser(error);
			}
		}
	};

	return { loading, data, refetch, acceptJoinInvitePress, rejectJoinInvitePress };
};
